import React, { useEffect, useState } from "react";
import { Trash, ChatCircleDots, ArrowsClockwise } from "@phosphor-icons/react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function CommentsModeration() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/comments");
      setComments(data || []);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this comment permanently?")) return;
    try {
      await api.delete(`/admin/comments/${id}`);
      setComments((arr) => arr.filter((c) => c.id !== id));
      toast.success("Comment deleted");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <section className="space-y-4" data-testid="comments-moderation">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <p className="text-xs font-bold tracking-[0.3em] text-neon-cyan uppercase mb-1 inline-flex items-center gap-2">
            <ChatCircleDots size={14} weight="fill" /> Comments Moderation
          </p>
          <h2 className="text-2xl sm:text-3xl font-black tracking-tighter">Keep it clean.</h2>
          <p className="text-sm text-zinc-500 mt-1">Review fan comments across all tracks — delete anything inappropriate in one click.</p>
        </div>
        <button onClick={load} className="px-3 py-1.5 rounded-md border border-ink-600 text-zinc-300 hover:text-neon-cyan text-xs inline-flex items-center gap-1.5" data-testid="comments-refresh">
          <ArrowsClockwise size={12} /> Reload
        </button>
      </div>
      {loading && <p className="text-zinc-500 text-sm">Loading comments…</p>}
      {!loading && comments.length === 0 && (
        <p className="text-zinc-500 text-sm py-6 text-center border border-ink-600 rounded-md bg-ink-800/30">No comments yet.</p>
      )}
      {!loading && comments.length > 0 && (
        <ul className="space-y-2">
          {comments.map((c) => (
            <li key={c.id} className="rounded-md border border-ink-600 bg-ink-800/40 p-3 flex items-start justify-between gap-3" data-testid={`comment-row-${c.id}`}>
              <div className="min-w-0 flex-1">
                <p className="text-xs text-neon-cyan font-mono">
                  #{String(c.slot_rank).padStart(2, "0")} · {c.name}
                  <span className="text-zinc-600 ml-2">{new Date(c.created_at).toLocaleString()}</span>
                </p>
                <p className="text-sm text-zinc-200 leading-relaxed mt-1 break-words">{c.comment}</p>
              </div>
              <button
                onClick={() => remove(c.id)}
                className="shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-ink-600 text-zinc-300 hover:text-neon-magenta hover:border-neon-magenta/50 text-xs transition-colors"
                data-testid={`comment-delete-${c.id}`}
              >
                <Trash size={12} /> Delete
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
